import get from 'lodash/get';

const copyToClipboard = (text) => {
  const clipboard = get(navigator, 'clipboard', null);
  const result = clipboard
    ? clipboard.writeText(text)
    : Promise.reject(new Error('Clipboard API is not available'));

  result.catch(() => {});

  return result;
};

export default copyToClipboard;
